import React from 'react';

interface AnimatedParticlesProps {
    count?: number;
}

const AnimatedParticles: React.FC<AnimatedParticlesProps> = ({ count = 40 }) => {
    const dots = Array.from({ length: count });

    return (
        <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
            {dots.map((_, i) => {
                const size = Math.random() * 3 + 1;
                const style: React.CSSProperties = {
                    left: `${Math.random() * 100}%`,
                    width: `${size}px`,
                    height: `${size}px`,
                    animationDuration: `${10 + Math.random() * 10}s`,
                    animationDelay: `${Math.random() * 15}s`,
                    ['--opacity' as any]: Math.random() * 0.5 + 0.2,
                };
                return <span key={i} className="levitating-dot" style={style} />;
            })}
        </div>
    );
};

export default AnimatedParticles;